/**
 * Created by Carsten Bühler on 24.10.2016.
 */

import L from 'external/leaflet';
import { getBoundsFromGeometry } from './geo-utils';
import { DefaultFeatureRenderer } from '../FeatureRenderer/DefaultFeatureRenderer';
import { stateToValueMap } from './feature-util';

const LoadingIcon = L.Icon.extend({
    options: {
        iconUrl: '/map-portlet/assets/marker-icon-red.png',
        popupAnchor: [ 0, -50 ],
        iconSize: [ 25, 41 ],
        iconAnchor: [ 12, 41 ]
    }
});

export default {

    /**
     Attention!
     This methods replacing the given layer with a new created.
     This only works if no handlers or other reverences are wired to the layer.

     selfReplacingLoadingMarker(feature, options, rendererLoadingPromise) {
        const bounds = getBoundsFromGeometry(feature);
        return new LoadingMarker(bounds.getCenter(), feature, options, rendererLoadingPromise).setIcon(new LoadingIcon());
    },     */

    loadingMarker(feature) {
        const bounds = getBoundsFromGeometry(feature);
        return L.marker(bounds.getCenter()).setIcon(new LoadingIcon());
    },

    renderCluster(cluster) {

        const children = cluster.getAllChildMarkers();
        let clusterOverallState;
        for (let featureLayer of children) {
            const overallState = featureLayer.feature.properties.overallState;
            if (!clusterOverallState && overallState) {
                clusterOverallState = overallState;
            }
            if (overallState && stateToValueMap[ clusterOverallState ] < stateToValueMap[ overallState ]) {
                clusterOverallState = overallState;
            }

            if (overallState === 'red') {
                break;
            }
        }

        const childCount = cluster.getChildCount();

        return new L.DivIcon({
            html: '<div><span>' + childCount + '</span></div>',
            className: 'marker-cluster marker-cluster-small ' + clusterOverallState,
            iconSize: new L.Point(40, 40)
        });
    },

    createFeatureLayer(feature, options = {}, returnPromiseOnMissing) {
        let renderer = new DefaultFeatureRenderer();
        let layer = renderer.createFeatureLayer(feature, options);
        layer.feature = feature;
        return layer;
    }
};



// WEBPACK FOOTER //
// ./js/utils/FeatureManager.js